import { createAction, props } from '@ngrx/store'
import type { User } from './auth.model'

// login action — no credentials: it starts the OAuth2 redirect to Identity (Authorization Code + PKCE).
export const login = createAction('[Authentication] Login')
export const loginSuccess = createAction(
  '[Authentication] Login Success',
  props<{ user: User; token: string }>()
)
export const loginFailure = createAction(
  '[Authentication] Login Failure',
  props<{ error: any }>()
)

// refresh the stored user claims once the OIDC lib has fully processed them (post code-exchange). Separate
// from loginSuccess so it updates state.user WITHOUT re-triggering the login effects.
export const setUser = createAction(
  '[Authentication] Set User',
  props<{ user: User }>()
)

// logout action
export const logout = createAction('[Authentication] Logout')

export const logoutSuccess = createAction('[Auth] Logout Success')
